export default {
  id: "skeletal-animation-assignment",
  pride: 14336,
  slug: "skeletal-animation-assignment",
  portfolioKind: "study",
  category: "game",
  status: "released",
  titleKey: {
    zh: "纯C++《骨骼动画》游戏作业",
    en: "Pure C++ Skeletal Animation — Game Assignment"
  },
  bilibiliVideoId: "BV1yG4y1a7mD",
  date: { year: 2022, month: 8, day: 21 },
  descriptionKey: {
    zh: "课程作业。neta鬼泣5和FF14 5.0CG。未使用Timeline/Sequence，动作部分自制。",
    en: "Course assignment. References Devil May Cry 5 and FF14 5.0 CG. No Timeline or Sequence used — all animations self-made."
  },
  genres: ["动作", "课程作业"],
  themes: ["骨骼动画", "C++"],
  engine: "虚幻引擎",
  platform: ["PC"],
  developerNotesKey: {
    zh: "《骨骼动画》课程游戏制作作业。neta了鬼泣5和FF14 5.0 CG。未使用Timeline和Sequence，动作部分为自制。纯C++。",
    en: "Game assignment for the Skeletal Animation course. References Devil May Cry 5 and FF14 5.0 CG. No Timeline or Sequence used. All action sequences self-authored in pure C++."
  },
  tags: ["C++", "课程作业"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1yG4y1a7mD/", textKey: { zh: "B站视频", en: "Bilibili Video" } }
  ]
};
